import React from 'react';

/**
 * Um componente de spinner de carregamento simples e reutilizável.
 * Utiliza Tailwind CSS para estilização e animação.
 * @param {{size: 'sm' | 'md' | 'lg'}} props - O tamanho do loader. O padrão é 'md'.
 */
export const Loader = ({ size = 'md' }) => {
    const sizeClasses = {
        sm: 'w-5 h-5 border-2',
        md: 'w-8 h-8 border-4',
        lg: 'w-12 h-12 border-4',
    };

    return (
        <div
            className={`
                animate-spin 
                rounded-full 
                ${sizeClasses[size]} 
                border-blue-500 
                border-t-transparent
            `}
            role="status"
        >
            <span className="sr-only">A carregar...</span>
        </div>
    );
};

// Exporta o componente para que possa ser importado com `import { Loader } from ...`
export default Loader;
